import React, { useState } from 'react';
import { CodeSandboxOutlined, WalletOutlined, DashboardOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Layout, Menu, Popover, theme } from 'antd';
import DashboardRoutes from './dashboardRoutes.jsx';
import * as JImg from '../../assets/index'
import { useNavigate } from 'react-router-dom';
import './main.css';
import '../pages/dashboard/dashboard.css'
import '../pages/buildingView/building.css'
const { Header, Content, Sider } = Layout;
// const items1: MenuProps['items'] = ['1', '2', '3'].map((key) => ({
//   key,
//   label: `nav ${key}`,
// }));

const items = [{
    key: '1',
    // <Popover content={itm.title} trigger="hover" color='black' placement="right">
    icon: <DashboardOutlined style={{ fontSize: 24, display: "block" }} />,//DashboardOutlined,
    path: '/admin/main',
    title: 'Home',
}, {
    key: '2',
    icon: <WalletOutlined style={{ fontSize: 24, display: "block" }} />, //WalletOutlined,
    title: 'Reports',
    path: '/admin/report',
}, {
    key: '3',
    icon: <CodeSandboxOutlined style={{ fontSize: 24, display: "block" }} />, //CodeSandboxOutlined,
    title: 'Assets',
    path: '/admin/asset',
}];
// .map(
//     (item, index) => {
//         const key = String(index + 1);

//         return {
//             key: `sub${key}`,
//             icon: React.createElement(item.icon),
//             label: `${item.title}`,
//             collapsedIconSize: 22,
//             onClick: () => {

//             },
//             render: (item) => { <div></div> }

//             // children: new Array(4).fill(null).map((_, j) => {
//             //   const subKey = index * 4 + j + 1;
//             //   return {
//             //     key: subKey,
//             //     label: `option${subKey}`,
//             //   };
//             // }),
//         };
//     },
// );

const Main = () => {
    const navigate = useNavigate();
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const [collapsed, setCollapsed] = useState(true);
    const [selectedItem, setSelectedItem] = useState('1');
    const [selectedTime, setSelectedTime] = useState('month');
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
     
    return (
        <Layout style={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header style={{ display: 'flex', alignItems: 'center', background: '#ba1621', height:"60px" }}>
                <div className='row align-items-center'>
                    <div className='col-6 col-sm-4'>
                        <img src={JImg.LogoPng} width={50} height={50} style={{ objectFit: 'contain' }} />
                    </div>
                    <div className='col-6 col-sm-4 d-flex align-items-center justify-content-center'>
                        <div className='c-home-month-tab'>
                            <div className={'c-tab ' + (selectedTime == 'today' ? 'active' : '')} onClick={() => {
                                setSelectedTime('today');
                            }}>
                                Today
                            </div>
                            <div className={'c-tab ' + (selectedTime == 'month' ? 'active' : '')} onClick={() => {
                                setSelectedTime('month');
                            }}>
                                Month
                            </div>
                            <div className={'c-tab ' + (selectedTime == 'year' ? 'active' : '')} onClick={() => {
                                setSelectedTime('year');
                            }}>
                                Year
                            </div>
                        </div>
                    </div>
                    <div className='d-none d-sm-block col-sm-4 col-12 p-0'>
                        <div className='row align-items-center'>
                            <div className='col-10 p-0'>
                                <div className='header-profile'>
                                    <h6 className='m-0 header-title text-end'>Welcome, Eddie Neo</h6>
                                    <p className='m-0 header-date text-end'>09/09/2024, 16:56 hrs</p>
                                </div>
                            </div>
                            <div className='col-2 profile-img'>
                                <img src='https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png' width={36} height={36} style={{ objectFit: 'contain', borderRadius: "50%" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </Header>
            <Layout style={{flexGrow:'1',height:"cal(100vh - 80px)"}}>
                <Sider width={200} style={{ background: colorBgContainer }} collapsed={true}>
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={[selectedItem]}
                        className='main-side-menu'
                        selectedKeys={[selectedItem]}
                        onChange={(event) => {
                            console.log(event);
                        }}
                    >
                        {
                            items.map((itm, i) => {
                                return <Menu.Item key={itm.key} title={itm.title} className='menu-item' onClick={() => {
                                    setSelectedItem(itm.key);
                                    navigate(itm.path);
                                }} style={{ height: 'max-content' }}>
                                    {itm.icon}
                                    <p className='m-0' style={{ lineHeight: 'normal', fontSize: 12 }}>{itm.title}</p>
                                </Menu.Item>
                            })
                        }
                    </Menu>
                </Sider>
                <Layout>
                    {/* <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>List</Breadcrumb.Item>
            <Breadcrumb.Item>App</Breadcrumb.Item>
          </Breadcrumb> */}

                    {/* <div>

                        <Button type="primary" onClick={toggleCollapsed} style={{ marginBottom: 16 }}>
                            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        </Button>
                    </div> */}
                    <Content
                        style={{
                            margin: 0,
                            height: "100%",
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    >
                        <div className='c-content-page'>
                            {/* {selectedItem} */}
                            <DashboardRoutes />
{/* 
                            {selectedItem == 1 && <DashboardPage /> }
                            {selectedItem == 2 && <ReportsPage /> } */}
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default Main;